import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ITheme = {
  isDark: boolean;
  isBottomSheetOpen: boolean;
};

const initialState: ITheme = {
  isDark: true,
  isBottomSheetOpen: false,
};
export const ThemeSlice = createSlice({
  name: "theme_slice",
  initialState,
  reducers: {
    setIsDark: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem("isDarkMode", "true");
      state.isDark = true;
    },
    setBottomSheet: (state, action: PayloadAction<boolean>) => {
      state.isBottomSheetOpen = action.payload;
    },
  },
});

export const { setIsDark, setBottomSheet } = ThemeSlice.actions;

export default ThemeSlice.reducer;
